import React from 'react';
import {ChooseDropdown} from '@priority-software/priority-style-react';
import {
    DropdownItemData,
    DropdownValueType
} from '@priority-software/priority-style-react/dist/components/DropdownV2/ChooseDropdown/ChooseDropdown';
import {ruleDialogID} from '../../../../../../constants';
import {TextTrigger} from './TextTrigger';

type Props = {
    data: Array<DropdownItemData>;
    value: DropdownValueType;
    onChange: (option: DropdownItemData, isSelected: boolean, name?: string) => void;
    portalSelector?: string;
    hasSearch?: boolean;
    name?: string;
    disabled?: boolean;
};

export const TextDropdown = (props: Props) => {
    const {data, value, portalSelector = ruleDialogID, hasSearch, onChange, name, disabled} = props;

    const selectedLabel = (data.find(option => option.value === value) || data[0]).label;

    return (
        <div style={{display: 'inline-flex'}}>
            <ChooseDropdown
                data={data}
                value={value}
                onChange={onChange}
                trigger={<TextTrigger value={selectedLabel} />}
                usePortal={true}
                portalSelector={portalSelector}
                hasSearch={hasSearch}
                name={name}
                disabled={disabled}
            />
        </div>
    );
};
